import { Unread } from '@pt/api/message/enum'
import { language } from '@/common/storage'
import { setMessageRead } from '@pt/api/message'
import { LangsType, MessageType } from '@pt/api/message/index.type'

export const colorStyle = (status: Unread): string => {
  return status === Unread.Send ? '#EA1B26' : '#EDEDED'
}

export const getMessageTitle = (langsList: LangsType[]): string => {
  if (langsList.length === 1) {
    return langsList[0]?.title || ''
  }
  return (
    (langsList && langsList.find((s) => s.lang === language.get())?.title) || ''
  )
}

export const getMessageContent = (langsList: LangsType[]): string => {
  if (langsList.length === 1) {
    return langsList[0]?.content || ''
  }
  return (
    (langsList && langsList.find((s) => s.lang === language.get())?.content) ||
    ''
  )
}

export const setMessageReadFun = async (
  msg_ids: {
    id: MessageType['msg_id']
    seq: MessageType['seq']
  }[],
): Promise<boolean> => {
  try {
    await setMessageRead(msg_ids)
    return true
  } catch (error) {
    console.log(error)
    return false
  }
}

// 查看抽屉列表
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handleDrawerList = async (data: MessageType[]) => {
  data.map((t) => (t.show = false))

  if (data[0]?.status === Unread.Send) {
    const flag = await setMessageReadFun([
      { id: data[0]?.msg_id, seq: data[0]?.seq },
    ])
    if (flag) {
      data[0].status = Unread.Read
    }
    data[0].show = true
  }
}
